import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useAdminModuleV2 = (moduleId: string) => {
  const service = useServices().moduleListV2Service;
  return useQuery({
    queryKey: ['adminModuleV2', moduleId],
    queryFn: () => service.getModule(moduleId),
    enabled: !!moduleId,
    refetchOnWindowFocus: false,
  });
};
